import axios from "axios";
import SideNavbar from "../../../components/common/SideNavbar";
import TopNavbar from "../../../components/common/TopNavbar";
import { useEffect, useState } from "react";
import { Button, Spinner, Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { userTableCustomStyles } from "../../../utils/TableCustomStyles";

function OwnerMaster() {
  const [menuDrawerShow, setMenuDrawerShow] = useState(true);
  const [data, setData] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [portList, setPortList] = useState([]);
  const [dataPending, setDataPending] = useState(true);
  const [currentUserRolePermissionData, setCurrentUserRolePermissionData] =
    useState([]);
  const [dataFromTopNavBar, setDataFromTopNavBar] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const user_role = sessionStorage["userrole"];
  const user_id = sessionStorage["id"];
  const [loggedInUser, setLoggedInUser] = useState(null);

  // Canvas visibility
  const [showAddCanvas, setShowAddCanvas] = useState(false);
  const [showUpdateCanvas, setShowUpdateCanvas] = useState(false);
  const [canvasAddFullScreen, setCanvasAddFullScreen] = useState(false);
  const [canvasUpdateFullScreen, setCanvasUpdateFullScreen] = useState(false);

  // Loaders
  const [showAddLoader, setShowAddLoader] = useState(false);
  const [showUpdateLoader, setShowUpdateLoader] = useState(false);
  const [showDeleteLoader, setShowDeleteLoader] = useState(false);

  const [recordForDelete, setRecordForDelete] = useState(null);

  // ---------- Add form state ----------
  const [addName, setAddName] = useState("");
  const [addCompany, setAddCompany] = useState("");
  const [addCountry, setAddCountry] = useState("");
  const [addPort, setAddPort] = useState("");
  const [addAddressLine1, setAddAddressLine1] = useState("");
  const [addAddressLine2, setAddAddressLine2] = useState("");
  const [addCity, setAddCity] = useState("");
  const [addState, setAddState] = useState("");
  const [addPincode, setAddPincode] = useState("");
  const [addEmail, setAddEmail] = useState("");
  const [addMobileNumber, setAddMobileNumber] = useState("");
  const [addLandlineNumber, setAddLandlineNumber] = useState("");
  const [addStatus, setAddStatus] = useState("ACTIVE");

  // Add field errors
  const [showNameError, setShowNameError] = useState(false);
  const [showCompanyError, setShowCompanyError] = useState(false);
  const [showCountryError, setShowCountryError] = useState(false);
  const [showPortError, setShowPortError] = useState(false);
  const [showAddressLine1Error, setShowAddressLine1Error] = useState(false);
  const [showAddressLine2Error, setShowAddressLine2Error] = useState(false);
  const [showCityError, setShowCityError] = useState(false);
  const [showStateError, setShowStateError] = useState(false);
  const [showPincodeError, setShowPincodeError] = useState(false);
  const [showEmailError, setShowEmailError] = useState(false);
  const [showMobileNumberError, setShowMobileNumberError] = useState(false);
  const [showLandlineNumberError, setShowLandlineNumberError] = useState(false);

  // Add validation summary
  const [showValidationError, setShowValidationError] = useState(false);
  const [validationErrorArray, setValidationErrorArray] = useState([]);
  const [isValidationErrorVisible, setIsValidationErrorVisible] =
    useState(false);

  // ---------- Update form state ----------
  const [updateId, setUpdateId] = useState("");
  const [updateName, setUpdateName] = useState("");
  const [updateCompany, setUpdateCompany] = useState("");
  const [updateCountry, setUpdateCountry] = useState("");
  const [updatePort, setUpdatePort] = useState("");
  const [updateAddressLine1, setUpdateAddressLine1] = useState("");
  const [updateAddressLine2, setUpdateAddressLine2] = useState("");
  const [updateCity, setUpdateCity] = useState("");
  const [updateState, setUpdateState] = useState("");
  const [updatePincode, setUpdatePincode] = useState("");
  const [updateEmail, setUpdateEmail] = useState("");
  const [updateMobileNumber, setUpdateMobileNumber] = useState("");
  const [updateLandlineNumber, setUpdateLandlineNumber] = useState("");
  const [updateStatus, setUpdateStatus] = useState("ACTIVE");

  // Update field errors
  const [showUpdateNameError, setShowUpdateNameError] = useState(false);
  const [showUpdateCompanyError, setShowUpdateCompanyError] = useState(false);
  const [showUpdateCountryError, setShowUpdateCountryError] = useState(false);
  const [showUpdatePortError, setShowUpdatePortError] = useState(false);
  const [showUpdateAddressLine1Error, setShowUpdateAddressLine1Error] =
    useState(false);
  const [showUpdateAddressLine2Error, setShowUpdateAddressLine2Error] =
    useState(false);
  const [showUpdateCityError, setShowUpdateCityError] = useState(false);
  const [showUpdateStateError, setShowUpdateStateError] = useState(false);
  const [showUpdatePincodeError, setShowUpdatePincodeError] = useState(false);
  const [showUpdateEmailError, setShowUpdateEmailError] = useState(false);
  const [showUpdateMobileNumberError, setShowUpdateMobileNumberError] =
    useState(false);
  const [showUpdateLandlineNumberError, setShowUpdateLandlineNumberError] =
    useState(false);

  // Update validation summary
  const [showUpdateValidationError, setShowUpdateValidationError] =
    useState(false);
  const [updateValidationErrorArray, setUpdateValidationErrorArray] = useState(
    [],
  );
  const [isUpdateValidationErrorVisible, setIsUpdateValidationErrorVisible] =
    useState(false);

  // ========== Validation Helpers ==========
  const isNumeric = (val) => /^\d+$/.test(val);
  const isAlphabetic = (val) => /^[A-Za-z]+$/.test(val); // only letters, no spaces
  const isValidEmail = (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
  const isValidMobile = (val) => /^\d{9,11}$/.test(val);

  // ========== Real‑time error helpers ==========
  const hasAnyAddError = () => {
    return (
      showNameError ||
      showCompanyError ||
      showCountryError ||
      showPortError ||
      showAddressLine1Error ||
      showAddressLine2Error ||
      showCityError ||
      showStateError ||
      showPincodeError ||
      showEmailError ||
      showMobileNumberError ||
      showLandlineNumberError
    );
  };

  const buildAddErrorMessages = () => {
    const errors = [];
    if (!addName) errors.push("Name is required");
    if (!addCompany) errors.push("Company is required");
    if (!addCountry) errors.push("Country is required");
    if (!addPort) errors.push("Port is required");
    if (!addAddressLine1) errors.push("Address Line 1 is required");
    if (!addAddressLine2) errors.push("Address Line 2 is required");
    if (!addCity) errors.push("City is required");
    if (!addState) errors.push("State is required");
    else if (!isAlphabetic(addState))
      errors.push(
        "State must contain only letters (no spaces, numbers, or special characters)",
      );
    if (!addPincode) errors.push("Pincode is required");
    else if (!isNumeric(addPincode))
      errors.push("Pincode must contain only digits");
    if (!addEmail) errors.push("Email is required");
    else if (!isValidEmail(addEmail))
      errors.push("Email must be a valid email address");
    if (!addMobileNumber) errors.push("Mobile Number is required");
    else if (!isNumeric(addMobileNumber))
      errors.push("Mobile Number must contain only digits");
    if (!addLandlineNumber) errors.push("Landline Number is required");
    else if (!isNumeric(addLandlineNumber))
      errors.push("Landline Number must contain only digits");
    return errors;
  };

  const hasAnyUpdateError = () => {
    return (
      showUpdateNameError ||
      showUpdateCompanyError ||
      showUpdateCountryError ||
      showUpdatePortError ||
      showUpdateAddressLine1Error ||
      showUpdateAddressLine2Error ||
      showUpdateCityError ||
      showUpdateStateError ||
      showUpdatePincodeError ||
      showUpdateEmailError ||
      showUpdateMobileNumberError ||
      showUpdateLandlineNumberError
    );
  };

  const buildUpdateErrorMessages = () => {
    const errors = [];
    if (!updateName) errors.push("Name is required");
    if (!updateCompany) errors.push("Company is required");
    if (!updateCountry) errors.push("Country is required");
    if (!updatePort) errors.push("Port is required");
    if (!updateAddressLine1) errors.push("Address Line 1 is required");
    if (!updateAddressLine2) errors.push("Address Line 2 is required");
    if (!updateCity) errors.push("City is required");
    if (!updateState) errors.push("State is required");
    else if (!isAlphabetic(updateState))
      errors.push(
        "State must contain only letters (no spaces, numbers, or special characters)",
      );
    if (!updatePincode) errors.push("Pincode is required");
    else if (!isNumeric(updatePincode))
      errors.push("Pincode must contain only digits");
    if (!updateEmail) errors.push("Email is required");
    else if (!isValidEmail(updateEmail))
      errors.push("Email must be a valid email address");
    if (!updateMobileNumber) errors.push("Mobile Number is required");
    else if (!isNumeric(updateMobileNumber))
      errors.push("Mobile Number must contain only digits");
    if (!updateLandlineNumber) errors.push("Landline Number is required");
    else if (!isNumeric(updateLandlineNumber))
      errors.push("Landline Number must contain only digits");
    return errors;
  };

  // Tooltip toggles
  const handleCheckValidationClick = () =>
    setIsValidationErrorVisible(!isValidationErrorVisible);
  const handleUpdateCheckValidationClick = () =>
    setIsUpdateValidationErrorVisible(!isUpdateValidationErrorVisible);

  // ========== API calls ==========
  const getLoggedInUser = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/user/" + user_id,
      );
      setLoggedInUser(response.data);
    } catch (err) {
      toast.error("Error in fetching user data! Try again.");
    }
  };

  const getOwner = async () => {
    try {
      setDataPending(true);
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/master/owner/",
      );
      setData(response.data);
    } catch (err) {
      toast.error("Error in fetching owner data! Try again.");
    } finally {
      setDataPending(false);
    }
  };

  const getCountry = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/country/",
      );
      const sorted_data = response.data.sort(
        (a, b) => a.object_id - b.object_id,
      );
      setCountryList(sorted_data);
    } catch (err) {
      toast.error("Error in fetching country data! Try again.");
    }
  };

  const getPort = async (country) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/port/getportbycountry?country=" +
          country,
      );
      const sorted_data = response.data.sort((a, b) =>
        a.name.localeCompare(b.name),
      );
      setPortList(sorted_data);
    } catch (err) {
      toast.error("Error in fetching port data! Try again.");
    }
  };

  const getCurrentUserRolePermission = async (roles) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/role/getuserrolepermission?roles=" +
          roles,
      );
      const role_permissions_array = [];
      for (let i = 0; i < response.data?.length; i++) {
        for (let j = 0; j < response?.data[i]?.permissions_array?.length; j++) {
          if (
            !role_permissions_array.includes(
              response?.data[i]?.permissions_array?.[j],
            )
          ) {
            role_permissions_array.push(
              response?.data[i]?.permissions_array?.[j],
            );
          }
        }
      }
      setCurrentUserRolePermissionData(role_permissions_array);
    } catch (err) {
      toast.error("Error in fetching user role data! Try again.");
    }
  };

  useEffect(() => {
    getLoggedInUser();
    getOwner();
    getCountry();
  }, []);

  useEffect(() => {
    getCurrentUserRolePermission(user_role);
  }, [user_role]);

  // ========== Delete handlers ==========
  const handleDeleteModalClose = () => setShowDeleteModal(false);
  const handleDeleteModalOpen = (data) => {
    setShowDeleteModal(true);
    setRecordForDelete(data);
  };

  const deleteSelectedRecord = async (id) => {
    setShowDeleteLoader(true);
    try {
      await axios.delete(
        process.env.REACT_APP_BACKEND_API_URL + "/master/owner/" + id + "/",
      );
      setShowDeleteModal(false);
      getOwner();
      toast.success("Record deleted successfully");
    } catch (err) {
      toast.error("Error in deleting record! Try again.");
    }
    setShowDeleteLoader(false);
  };

  // ========== Add logic ==========
  const resetAddForm = () => {
    setAddName("");
    setAddCompany("");
    setAddCountry("");
    setAddPort("");
    setAddAddressLine1("");
    setAddAddressLine2("");
    setAddCity("");
    setAddState("");
    setAddPincode("");
    setAddEmail("");
    setAddMobileNumber("");
    setAddLandlineNumber("");
    setAddStatus("ACTIVE");
    setShowNameError(false);
    setShowCompanyError(false);
    setShowCountryError(false);
    setShowPortError(false);
    setShowAddressLine1Error(false);
    setShowAddressLine2Error(false);
    setShowCityError(false);
    setShowStateError(false);
    setShowPincodeError(false);
    setShowEmailError(false);
    setShowMobileNumberError(false);
    setShowLandlineNumberError(false);

    setShowValidationError(false);
    setValidationErrorArray([]);
    setIsValidationErrorVisible(false);
    setPortList([]); // Clear port list when country changes
  };

  const handleAddModalClose = () => {
    resetAddForm();
    setShowAddCanvas(false);
    setCanvasAddFullScreen(false);
  };

  const addNewOwner = async (e) => {
    e.preventDefault();

    setShowNameError(!addName);
    setShowCompanyError(!addCompany);
    setShowCountryError(!addCountry);
    setShowPortError(!addPort);
    setShowAddressLine1Error(!addAddressLine1);
    setShowAddressLine2Error(!addAddressLine2);
    setShowCityError(!addCity);
    setShowStateError(!addState || !isAlphabetic(addState));
    setShowPincodeError(!addPincode || !isNumeric(addPincode));
    setShowEmailError(!addEmail || !isValidEmail(addEmail));
    setShowMobileNumberError(!addMobileNumber || !isNumeric(addMobileNumber));
    setShowLandlineNumberError(
      !addLandlineNumber || !isNumeric(addLandlineNumber),
    );
    setValidationErrorArray(buildAddErrorMessages());

    if (
      !addName ||
      !addCompany ||
      !addCountry ||
      !addPort ||
      !addAddressLine1 ||
      !addAddressLine2 ||
      !addCity ||
      !addState ||
      !addPincode ||
      !addEmail ||
      !addMobileNumber ||
      !addLandlineNumber ||
      !isAlphabetic(addState) ||
      !isNumeric(addPincode) ||
      !isValidEmail(addEmail) ||
      !isNumeric(addMobileNumber) ||
      !isNumeric(addLandlineNumber)
    ) {
      setShowValidationError(true);
      return;
    }

    setShowAddLoader(true);

    const payload = {
      name: addName,
      company_name: addCompany,
      port: addPort,
      address_line_1: addAddressLine1,
      address_line_2: addAddressLine2,
      city: addCity,
      state: addState,
      country: addCountry,
      pincode: addPincode,
      email: addEmail,
      mobile_number: addMobileNumber,
      landline_number: addLandlineNumber,
      status: addStatus,
      created_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
    };

    try {
      const response = await axios.post(
        process.env.REACT_APP_BACKEND_API_URL + "/master/owner/",
        payload,
        { headers: { "content-type": "application/json" } },
      );
      if (response.status === 201) {
        toast.success("Owner Created Successfully");
        handleAddModalClose();
        getOwner();
      }
    } catch (err) {
      toast.error("Error creating owner");
    } finally {
      setShowAddLoader(false);
    }
  };

  // ========== Update logic ==========
  const resetUpdateForm = () => {
    setUpdateId("");
    setUpdateName("");
    setUpdateCompany("");
    setUpdateCountry("");
    setUpdatePort("");
    setUpdateAddressLine1("");
    setUpdateAddressLine2("");
    setUpdateCity("");
    setUpdateState("");
    setUpdatePincode("");
    setUpdateEmail("");
    setUpdateMobileNumber("");
    setUpdateLandlineNumber("");
    setUpdateStatus("ACTIVE");
    setShowUpdateNameError(false);
    setShowUpdateCompanyError(false);
    setShowUpdateCountryError(false);
    setShowUpdatePortError(false);
    setShowUpdateAddressLine1Error(false);
    setShowUpdateAddressLine2Error(false);
    setShowUpdateCityError(false);
    setShowUpdateStateError(false);
    setShowUpdatePincodeError(false);
    setShowUpdateEmailError(false);
    setShowUpdateMobileNumberError(false);
    setShowUpdateLandlineNumberError(false);
    setShowUpdateValidationError(false);
    setUpdateValidationErrorArray([]);
    setIsUpdateValidationErrorVisible(false);
    setPortList([]);
  };

  const handleUpdateModalClose = () => {
    resetUpdateForm();
    setShowUpdateCanvas(false);
    setCanvasUpdateFullScreen(false);
  };

  const handleSetUpdateData = (row) => {
    setUpdateId(row.id);
    setUpdateName(row.name);
    setUpdateCompany(row.company_name);
    setUpdateCountry(row.country);
    setUpdatePort(row.port);
    setUpdateAddressLine1(row.address_line_1);
    setUpdateAddressLine2(row.address_line_2);
    setUpdateCity(row.city);
    setUpdateState(row.state);
    setUpdatePincode(row.pincode);
    setUpdateEmail(row.email);
    setUpdateMobileNumber(row.mobile_number);
    setUpdateLandlineNumber(row.landline_number);
    setUpdateStatus(row.status);
    getPort(row.country);
    // Reset errors
    setShowUpdateNameError(false);
    setShowUpdateCompanyError(false);
    setShowUpdateCountryError(false);
    setShowUpdatePortError(false);
    setShowUpdateAddressLine1Error(false);
    setShowUpdateAddressLine2Error(false);
    setShowUpdateCityError(false);
    setShowUpdateStateError(false);
    setShowUpdatePincodeError(false);
    setShowUpdateEmailError(false);
    setShowUpdateMobileNumberError(false);
    setShowUpdateLandlineNumberError(false);
    setShowUpdateValidationError(false);
    setUpdateValidationErrorArray([]);
  };

  const updateOwner = async (e) => {
    e.preventDefault();

    setShowUpdateNameError(!updateName);
    setShowUpdateCompanyError(!updateCompany);
    setShowUpdateCountryError(!updateCountry);
    setShowUpdatePortError(!updatePort);
    setShowUpdateAddressLine1Error(!updateAddressLine1);
    setShowUpdateAddressLine2Error(!updateAddressLine2);
    setShowUpdateCityError(!updateCity);
    setShowUpdateStateError(!updateState || !isAlphabetic(updateState));
    setShowUpdatePincodeError(!updatePincode || !isNumeric(updatePincode));
    setShowUpdateEmailError(!updateEmail || !isValidEmail(updateEmail));
    setShowUpdateMobileNumberError(
      !updateMobileNumber || !isNumeric(updateMobileNumber),
    );
    setShowUpdateLandlineNumberError(
      !updateLandlineNumber || !isNumeric(updateLandlineNumber),
    );
    setUpdateValidationErrorArray(buildUpdateErrorMessages());

    if (
      !updateName ||
      !updateCompany ||
      !updateCountry ||
      !updatePort ||
      !updateAddressLine1 ||
      !updateAddressLine2 ||
      !updateCity ||
      !updateState ||
      !updatePincode ||
      !updateEmail ||
      !updateMobileNumber ||
      !updateLandlineNumber ||
      !isAlphabetic(updateState) ||
      !isNumeric(updatePincode) ||
      !isValidEmail(updateEmail) ||
      !isNumeric(updateMobileNumber) ||
      !isNumeric(updateLandlineNumber)
    ) {
      setShowUpdateValidationError(true);
      return;
    }

    setShowUpdateLoader(true);

    const payload = {
      name: updateName,
      company_name: updateCompany,
      port: updatePort,
      address_line_1: updateAddressLine1,
      address_line_2: updateAddressLine2,
      city: updateCity,
      state: updateState,
      country: updateCountry,
      pincode: updatePincode,
      email: updateEmail,
      mobile_number: updateMobileNumber,
      landline_number: updateLandlineNumber,
      status: updateStatus,
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
    };

    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_API_URL +
          "/master/owner/" +
          updateId +
          "/",
        payload,
        { headers: { "content-type": "application/json" } },
      );
      if (response.status === 200) {
        toast.success("Owner Updated Successfully");
        handleUpdateModalClose();
        getOwner();
      }
    } catch (err) {
      toast.error("Error updating owner");
    } finally {
      setShowUpdateLoader(false);
    }
  };

  // ========== Table columns ==========
  const columns = [
    { name: "Name", selector: (row) => row.name, sortable: true },
    { name: "Company", selector: (row) => row.company_name, sortable: true },
    { name: "Port", selector: (row) => row.port_data?.name, sortable: true },
    {
      name: "Address",
      width: "500px",
      selector: (row) =>
        `${row.address_line_1}, ${row.address_line_2}, ${row.city}, ${row.state} - ${row.pincode}`,
      sortable: true,
    },
    {
      name: "Country",
      center: true,
      selector: (row) => (
        <div className="text-center">
          <img
            src={row.country_data?.image_url}
            height={20}
            width={35}
            style={{ marginBottom: 5 }}
            alt="flag"
          />
          <br />
          <span>{row.country_data?.long_name}</span>
        </div>
      ),
      sortable: true,
    },
    { name: "Email", selector: (row) => row.email, sortable: true },
    {
      name: "Mobile Number",
      selector: (row) => row.mobile_number,
      sortable: true,
    },
    {
      name: "Landline Number",
      selector: (row) => row.landline_number,
      sortable: true,
    },
    { name: "Status", selector: (row) => row.status, sortable: true },
    {
      name: "Action",
      center: true,
      selector: (row) => (
        <div>
          {currentUserRolePermissionData?.includes("master:owner:update") && (
            <Button
              className="btn btn-sm btn-inox-green border-0"
              title="Update"
              onClick={() => {
                handleSetUpdateData(row);
                setShowUpdateCanvas(true);
              }}
            >
              <i className="fa fa-edit"></i>
            </Button>
          )}
          {currentUserRolePermissionData?.includes("master:owner:delete") && (
            <Button
              className="btn btn-sm bg-danger border-0 mx-2"
              title="Delete"
              onClick={() => handleDeleteModalOpen(row)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          )}
        </div>
      ),
    },
  ];

  const handleDataFromTopNavBar = (permissiondata) =>
    setDataFromTopNavBar(permissiondata);

  return (
    <div className="page-content-bg">
      <ToastContainer />
      <TopNavbar
        sidebarCollapsed={menuDrawerShow}
        topNavbarStatic={true}
        sendDataToParent={handleDataFromTopNavBar}
      />
      <SideNavbar
        sidebarCollapsed={menuDrawerShow}
        activeMenu="Master"
        activeSubMenu="AdminMaster"
        activeSubMenuLevel1="OwnerMaster"
        permissionFromTopNavbar={dataFromTopNavBar}
      />

      <div
        className={
          menuDrawerShow
            ? "row main-content-collapsed text-left py-0"
            : "row main-content text-left py-0"
        }
      >
        <div className="col-12 page-header">
          <div className="row">
            <div className="col-6 py-1">
              <Button
                className="btn btn-sm btn-inox-green border-0 mx-2"
                onClick={() => setMenuDrawerShow(!menuDrawerShow)}
              >
                {menuDrawerShow ? (
                  <span>
                    <i className="fa fa-chevron-left mx-1"></i>
                  </span>
                ) : (
                  <span>
                    <i className="fa fa-chevron-right mx-1"></i>
                  </span>
                )}
              </Button>
              <span className="page-header-text">Owner Master</span>
            </div>
            <div className="col-6 py-1" style={{ paddingRight: 30 }}>
              {currentUserRolePermissionData?.includes("master:owner:add") ? (
                <Button
                  className="btn btn-sm btn-inox-green border-0 px-3 float-right"
                  onClick={() => {
                    resetAddForm();
                    setShowAddCanvas(true);
                  }}
                >
                  <i
                    className="fa fa-plus fa-lg text-right"
                    style={{ paddingRight: 10 }}
                  ></i>
                  <span className="fw-bold">Add Owner</span>
                </Button>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>

        <div
          className="col-12 text-left"
          style={{
            marginTop: -5,
            paddingLeft: 20,
            paddingRight: 30,
            zIndex: 100,
          }}
        >
          <DataTable
            columns={columns}
            data={data}
            progressPending={dataPending}
            progressComponent={
              <Spinner
                className="mx-5 text-inox-green table-spinner"
                as="span"
                animation="border"
                size="lg"
                role="status"
                aria-hidden="true"
              />
            }
            noDataComponent={
              <p className="text-center table-no-data">No Data Found</p>
            }
            pagination
            highlightOnHover
            fixedHeader
            customStyles={userTableCustomStyles}
            dense
          />
        </div>
      </div>

      {/* Delete Modal */}
      <Modal
        size="sm"
        show={showDeleteModal}
        onHide={handleDeleteModalClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteModalClose}>
            Close
          </Button>
          <Button
            variant="danger"
            onClick={() => deleteSelectedRecord(recordForDelete?.id)}
          >
            {showDeleteLoader ? (
              <Spinner
                className="mx-3 text-white"
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "Delete"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ------------------------ Update Canvas ------------------- */}
      <div
        className={
          canvasUpdateFullScreen && showUpdateCanvas
            ? "offcanvas offcanvas-bottom h-100 show"
            : !canvasUpdateFullScreen && showUpdateCanvas
              ? "offcanvas offcanvas-bottom h-50 show"
              : "offcanvas offcanvas-bottom h-50"
        }
        tabIndex="-1"
        aria-labelledby="updateCanvasLabel"
      >
        <div className="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="updateCanvasLabel" className="float-left">
                Update Record
              </h4>
            </div>
            <div className="col-6">
              <button
                type="button"
                className="btn btn-danger btn-sm float-right"
                aria-label="Close"
                title="Close"
                onClick={handleUpdateModalClose}
              >
                <i className="fa fa-times text-white"></i>
              </button>
              {canvasUpdateFullScreen ? (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Half Screen"
                  onClick={() => setCanvasUpdateFullScreen(false)}
                >
                  <i className="fa fa-window-minimize text-white"></i>
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Full Screen"
                  onClick={() => setCanvasUpdateFullScreen(true)}
                >
                  <i className="fa fa-window-maximize text-white"></i>
                </button>
              )}
            </div>
          </div>
        </div>

        <div
          className="offcanvas-body"
          style={{ paddingLeft: 20, paddingRight: 40 }}
        >
          <form onSubmit={updateOwner}>
            <div className="row">
              {/* Name */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="update_name">
                  Name:
                  <span className="text-danger">
                    {showUpdateNameError ? " Name required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="update_name"
                  placeholder="Enter Name"
                  value={updateName}
                  onChange={(e) => {
                    setUpdateName(e.target.value);
                    setShowUpdateNameError(false);
                    setShowUpdateValidationError(false);
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowUpdateNameError(e.target.value === "");
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                />
              </div>

              {/* Company */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="update_company">
                  Company:
                  <span className="text-danger">
                    {showUpdateCompanyError ? " Company required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="update_company"
                  placeholder="Enter Company Name"
                  value={updateCompany}
                  onChange={(e) => {
                    setUpdateCompany(e.target.value);
                    setShowUpdateCompanyError(false);
                    setShowUpdateValidationError(false);
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowUpdateCompanyError(e.target.value === "");
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                />
              </div>

              {/* Country */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="update_country">
                  Country:
                  <span className="text-danger">
                    {showUpdateCountryError ? " Country required" : ""}
                  </span>
                </label>
                <select
                  className="form-select form-select-sm"
                  id="update_country"
                  value={updateCountry}
                  onChange={(e) => {
                    setUpdateCountry(e.target.value);
                    setUpdatePort(""); // Reset port when country changes
                    getPort(e.target.value);
                    setShowUpdateCountryError(false);
                    setShowUpdateValidationError(false);
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowUpdateCountryError(e.target.value === "");
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                >
                  <option value="">Select Country</option>
                  {countryList.map((country) => (
                    <option key={country.id} value={country.id}>
                      {country.long_name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Port */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="update_port">
                  Port:
                  <span className="text-danger">
                    {showUpdatePortError ? " Port required" : ""}
                  </span>
                </label>
                <select
                  className="form-select form-select-sm"
                  id="update_port"
                  value={updatePort}
                  onChange={(e) => {
                    setUpdatePort(e.target.value);
                    setShowUpdatePortError(false);
                    setShowUpdateValidationError(false);
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowUpdatePortError(e.target.value === "");
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                >
                  <option value="">Select Port</option>
                  {portList.map((port) => (
                    <option key={port.id} value={port.id}>
                      {port.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Address Line 1 */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label
                  className="required-label"
                  htmlFor="update_address_line1"
                >
                  Address Line 1:
                  <span className="text-danger">
                    {showUpdateAddressLine1Error ? " Address required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="update_address_line1"
                  placeholder="Enter Address Line 1"
                  value={updateAddressLine1}
                  onChange={(e) => {
                    setUpdateAddressLine1(e.target.value);
                    setShowUpdateAddressLine1Error(false);
                    setShowUpdateValidationError(false);
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowUpdateAddressLine1Error(e.target.value === "");
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                />
              </div>

              {/* Address Line 2 */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label
                  className="required-label"
                  htmlFor="update_address_line2"
                >
                  Address Line 2:
                  <span className="text-danger">
                    {showUpdateAddressLine2Error ? " Address required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="update_address_line2"
                  placeholder="Enter Address Line 2"
                  value={updateAddressLine2}
                  onChange={(e) => {
                    setUpdateAddressLine2(e.target.value);
                    setShowUpdateAddressLine2Error(false);
                    setShowUpdateValidationError(false);
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowUpdateAddressLine2Error(e.target.value === "");
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                />
              </div>

              {/* City */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="update_city">
                  City:
                  <span className="text-danger">
                    {showUpdateCityError ? " City required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="update_city"
                  placeholder="Enter City"
                  value={updateCity}
                  onChange={(e) => {
                    setUpdateCity(e.target.value);
                    setShowUpdateCityError(false);
                    setShowUpdateValidationError(false);
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowUpdateCityError(e.target.value === "");
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                />
              </div>

              {/* State */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="update_state">
                  State:
                  <span className="text-danger">
                    {showUpdateStateError
                      ? updateState
                        ? " Must contain only letters"
                        : " Required"
                      : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="update_state"
                  placeholder="Enter State "
                  value={updateState}
                  onChange={(e) => {
                    setUpdateState(e.target.value);
                    setShowUpdateStateError(false);
                    setShowUpdateValidationError(false);
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                  onBlur={(e) => {
                    const val = e.target.value;
                    setShowUpdateStateError(!val || !isAlphabetic(val));
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                />
              </div>

              {/* Pincode */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="update_pincode">
                  Pincode:
                  <span className="text-danger">
                    {showUpdatePincodeError
                      ? updatePincode
                        ? " Must contain only digits"
                        : " Required"
                      : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="update_pincode"
                  placeholder="Enter Pincode"
                  value={updatePincode}
                  onChange={(e) => {
                    setUpdatePincode(e.target.value);
                    setShowUpdatePincodeError(false);
                    setShowUpdateValidationError(false);
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                  onBlur={(e) => {
                    const val = e.target.value;
                    setShowUpdatePincodeError(!val || !isNumeric(val));
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                />
              </div>

              {/* Email */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="update_email">
                  Email:
                  <span className="text-danger">
                    {showUpdateEmailError
                      ? updateEmail
                        ? " Invalid email format"
                        : " Required"
                      : ""}
                  </span>
                </label>
                <input
                  type="email"
                  className="form-control form-control-sm"
                  id="update_email"
                  placeholder="Enter Email"
                  value={updateEmail}
                  onChange={(e) => {
                    setUpdateEmail(e.target.value);
                    setShowUpdateEmailError(false);
                    setShowUpdateValidationError(false);
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                  onBlur={(e) => {
                    const val = e.target.value;
                    setShowUpdateEmailError(!val || !isValidEmail(val));
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                />
              </div>

              {/* Mobile Number */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label
                  className="required-label"
                  htmlFor="update_mobile_number"
                >
                  Mobile Number:
                  <span className="text-danger">
                    {showUpdateMobileNumberError
                      ? updateMobileNumber
                        ? " Must contain only digits"
                        : " Required"
                      : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="update_mobile_number"
                  placeholder="Enter Mobile Number "
                  value={updateMobileNumber}
                  onChange={(e) => {
                    setUpdateMobileNumber(e.target.value);
                    setShowUpdateMobileNumberError(false);
                    setShowUpdateValidationError(false);
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                  onBlur={(e) => {
                    const val = e.target.value;
                    setShowUpdateMobileNumberError(!val || !isValidMobile(val));
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                />
              </div>

              {/* Landline Number */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label
                  className="required-label"
                  htmlFor="update_landline_number"
                >
                  Landline Number:
                  <span className="text-danger">
                    {showUpdateLandlineNumberError
                      ? updateLandlineNumber
                        ? " Must contain only digits"
                        : " Required"
                      : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="update_landline_number"
                  placeholder="Enter Landline Number "
                  value={updateLandlineNumber}
                  onChange={(e) => {
                    setUpdateLandlineNumber(e.target.value);
                    setShowUpdateLandlineNumberError(false);
                    setShowUpdateValidationError(false);
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                  onBlur={(e) => {
                    const val = e.target.value;
                    setShowUpdateLandlineNumberError(!val || !isNumeric(val));
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                />
              </div>

              {/* Status */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-1" : "col-md-1"} text-left mb-4`}
              >
                <label htmlFor="update_status">Status:</label>
                <select
                  className="form-select form-select-sm"
                  id="update_status"
                  value={updateStatus}
                  onChange={(e) => setUpdateStatus(e.target.value)}
                >
                  <option value="ACTIVE">ACTIVE</option>
                  <option value="INACTIVE">INACTIVE</option>
                </select>
              </div>

              {/* Submit Button + Error Tooltip */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-12" : "col-md-12"}`}
              >
                <div className="canvas-btn-row">
                  <Button
                    type="submit"
                    className="btn btn-inox-green border-0 canvas-button"
                    disabled={hasAnyUpdateError() || showUpdateLoader}
                  >
                    {showUpdateLoader ? (
                      <Spinner
                        className="mx-4"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      <>
                        <i className="fa fa-edit"></i>{" "}
                        <span className="mx-2">Update</span>
                      </>
                    )}
                  </Button>

                  {(hasAnyUpdateError() || showUpdateValidationError) && (
                    <div className="error-tooltip-wrapper">
                      <Button
                        style={{
                          backgroundColor: "#C21E22",
                          border: "#f82e2e",
                        }}
                        title="Show Errors"
                        className="mx-2"
                        onClick={handleUpdateCheckValidationClick}
                        onMouseLeave={() =>
                          setIsUpdateValidationErrorVisible(false)
                        }
                      >
                        <i className="fa fa-exclamation"></i>
                      </Button>
                      {isUpdateValidationErrorVisible && (
                        <div className="validation-error-tooltip">
                          <ul className="mb-0 px-4">
                            {updateValidationErrorArray.map((error, index) => (
                              <li key={index} className="text-left small pb-0">
                                {error}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* ------------------------ Add Canvas ------------------- */}
      <div
        className={
          canvasAddFullScreen && showAddCanvas
            ? "offcanvas offcanvas-bottom h-100 show"
            : !canvasAddFullScreen && showAddCanvas
              ? "offcanvas offcanvas-bottom h-50 show"
              : "offcanvas offcanvas-bottom h-50"
        }
        tabIndex="-1"
        aria-labelledby="addCanvasLabel"
      >
        <div className="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="addCanvasLabel" className="float-left">
                Add New Record
              </h4>
            </div>
            <div className="col-6">
              <button
                type="button"
                className="btn btn-danger btn-sm float-right"
                aria-label="Close"
                title="Close"
                onClick={handleAddModalClose}
              >
                <i className="fa fa-times text-white"></i>
              </button>
              {canvasAddFullScreen ? (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Half Screen"
                  onClick={() => setCanvasAddFullScreen(false)}
                >
                  <i className="fa fa-window-minimize text-white"></i>
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Full Screen"
                  onClick={() => setCanvasAddFullScreen(true)}
                >
                  <i className="fa fa-window-maximize text-white"></i>
                </button>
              )}
            </div>
          </div>
        </div>

        <div
          className="offcanvas-body"
          style={{ paddingLeft: 20, paddingRight: 40 }}
        >
          <form onSubmit={addNewOwner}>
            <div className="row">
              {/* Name */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_name">
                  Name:
                  <span className="text-danger">
                    {showNameError ? " Name required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="add_name"
                  placeholder="Enter Name"
                  value={addName}
                  onChange={(e) => {
                    setAddName(e.target.value);
                    setShowNameError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowNameError(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* Company */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_company">
                  Company:
                  <span className="text-danger">
                    {showCompanyError ? " Company required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="add_company"
                  placeholder="Enter Company Name"
                  value={addCompany}
                  onChange={(e) => {
                    setAddCompany(e.target.value);
                    setShowCompanyError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowCompanyError(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* Country */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_country">
                  Country:
                  <span className="text-danger">
                    {showCountryError ? " Country required" : ""}
                  </span>
                </label>
                <select
                  className="form-select form-select-sm"
                  id="add_country"
                  value={addCountry}
                  onChange={(e) => {
                    setAddCountry(e.target.value);
                    setAddPort(""); // Reset port when country changes
                    getPort(e.target.value);
                    setShowCountryError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowCountryError(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                >
                  <option value="">Select Country</option>
                  {countryList.map((country) => (
                    <option key={country.id} value={country.id}>
                      {country.long_name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Port */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_port">
                  Port:
                  <span className="text-danger">
                    {showPortError ? " Port required" : ""}
                  </span>
                </label>
                <select
                  className="form-select form-select-sm"
                  id="add_port"
                  value={addPort}
                  onChange={(e) => {
                    setAddPort(e.target.value);
                    setShowPortError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowPortError(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                >
                  <option value="">Select Port</option>
                  {portList.map((port) => (
                    <option key={port.id} value={port.id}>
                      {port.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Address Line 1 */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_address_line1">
                  Address Line 1:
                  <span className="text-danger">
                    {showAddressLine1Error ? " Address required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="add_address_line1"
                  placeholder="Enter Address Line 1"
                  value={addAddressLine1}
                  onChange={(e) => {
                    setAddAddressLine1(e.target.value);
                    setShowAddressLine1Error(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowAddressLine1Error(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* Address Line 2 */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_address_line2">
                  Address Line 2:
                  <span className="text-danger">
                    {showAddressLine2Error ? " Address required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="add_address_line2"
                  placeholder="Enter Address Line 2"
                  value={addAddressLine2}
                  onChange={(e) => {
                    setAddAddressLine2(e.target.value);
                    setShowAddressLine2Error(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowAddressLine2Error(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* City */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_city">
                  City:
                  <span className="text-danger">
                    {showCityError ? " City required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="add_city"
                  placeholder="Enter City"
                  value={addCity}
                  onChange={(e) => {
                    setAddCity(e.target.value);
                    setShowCityError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowCityError(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* State */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_state">
                  State:
                  <span className="text-danger">
                    {showStateError
                      ? addState
                        ? " Must contain only letters"
                        : " Required"
                      : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="add_state"
                  placeholder="Enter State "
                  value={addState}
                  onChange={(e) => {
                    setAddState(e.target.value);
                    setShowStateError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    const val = e.target.value;
                    setShowStateError(!val || !isAlphabetic(val));
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* Pincode */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_pincode">
                  Pincode:
                  <span className="text-danger">
                    {showPincodeError
                      ? addPincode
                        ? " Must contain only digits"
                        : " Required"
                      : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="add_pincode"
                  placeholder="Enter Pincode "
                  value={addPincode}
                  onChange={(e) => {
                    setAddPincode(e.target.value);
                    setShowPincodeError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    const val = e.target.value;
                    setShowPincodeError(!val || !isNumeric(val));
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* Email */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_email">
                  Email:
                  <span className="text-danger">
                    {showEmailError
                      ? addEmail
                        ? " Invalid email format"
                        : " Required"
                      : ""}
                  </span>
                </label>
                <input
                  type="email"
                  className="form-control form-control-sm"
                  id="add_email"
                  placeholder="Enter Email"
                  value={addEmail}
                  onChange={(e) => {
                    setAddEmail(e.target.value);
                    setShowEmailError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    const val = e.target.value;
                    setShowEmailError(!val || !isValidEmail(val));
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* Mobile Number */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_mobile_number">
                  Mobile Number:
                  <span className="text-danger">
                    {showMobileNumberError
                      ? addMobileNumber
                        ? " Must contain only digits"
                        : " Required"
                      : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="add_mobile_number"
                  placeholder="Enter Mobile Number "
                  value={addMobileNumber}
                  onChange={(e) => {
                    setAddMobileNumber(e.target.value);
                    setShowMobileNumberError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    const val = e.target.value;
                    setShowMobileNumberError(!val || !isValidMobile(val));
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* Landline Number */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_landline_number">
                  Landline Number:
                  <span className="text-danger">
                    {showLandlineNumberError
                      ? addLandlineNumber
                        ? " Must contain only digits"
                        : " Required"
                      : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="add_landline_number"
                  placeholder="Enter Landline Number "
                  value={addLandlineNumber}
                  onChange={(e) => {
                    setAddLandlineNumber(e.target.value);
                    setShowLandlineNumberError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    const val = e.target.value;
                    setShowLandlineNumberError(!val || !isNumeric(val));
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* Status */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-1" : "col-md-1"} text-left mb-4`}
              >
                <label htmlFor="add_status">Status:</label>
                <select
                  className="form-select form-select-sm"
                  id="add_status"
                  value={addStatus}
                  onChange={(e) => setAddStatus(e.target.value)}
                >
                  <option value="ACTIVE">ACTIVE</option>
                  <option value="INACTIVE">INACTIVE</option>
                </select>
              </div>

              {/* Submit Button + Error Tooltip */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-12" : "col-md-12"}`}
              >
                <div className="canvas-btn-row">
                  <Button
                    type="submit"
                    className="btn btn-inox-green border-0 canvas-button"
                    disabled={hasAnyAddError() || showAddLoader}
                  >
                    {showAddLoader ? (
                      <Spinner
                        className="mx-4"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      <>
                        <i className="fa fa-plus"></i>{" "}
                        <span className="mx-2">Add</span>
                      </>
                    )}
                  </Button>

                  {(hasAnyAddError() || showValidationError) && (
                    <div className="error-tooltip-wrapper">
                      <Button
                        style={{
                          backgroundColor: "#C21E22",
                          border: "#f82e2e",
                        }}
                        title="Show Errors"
                        className="mx-2"
                        onClick={handleCheckValidationClick}
                        onMouseLeave={() => setIsValidationErrorVisible(false)}
                      >
                        <i className="fa fa-exclamation"></i>
                      </Button>
                      {isValidationErrorVisible && (
                        <div className="validation-error-tooltip">
                          <ul className="mb-0 px-4">
                            {validationErrorArray.map((error, index) => (
                              <li key={index} className="text-left small pb-0">
                                {error}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default OwnerMaster;
